module.exports = "pegasus/assets/f-icon1.png";